import { render, staticRenderFns } from "./pointRule.vue?vue&type=template&id=a8ebc50c&"
import script from "./pointRule.vue?vue&type=script&lang=js&"
export * from "./pointRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports